import { UTP } from './constants';
import * as styles from './styles.css';
import { UtpItem } from '../BypassUtp';
import { useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';

export const BypassAlternatives: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>Обойдите всех конкурентов</div>
      <div className={styles['utp']}>
        {UTP.map((item, index) => (
          <UtpItem key={index} {...item} device={device} index={index} />
        ))}
      </div>
    </div>
  );
};
